// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import TaskEditScreen from "../../src/screens/tasks/edit-screen"
import ScreenTitle from "../../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} TaskNewRouteProps */

/** @typedef {Record<string, never>} TaskNewRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<TaskNewRouteProps, TaskNewRouteState>}
 */
class TaskNewRoute extends ShapeComponent {
  /** Initializes route hooks. */
  setup() {
    useLocale()
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("New task")}</ScreenTitle>
        <TaskEditScreen />
      </>
    )
  }
}

/** @type {NamedExoticComponent<TaskNewRouteProps>} */
const TaskNewRouteComponent = memo(shapeComponent(TaskNewRoute))

export default TaskNewRouteComponent
